import React from 'react';
import Main from './Main';
import { Card, CardBody, Tab, Tabs } from '@nextui-org/react';
import Title from "../Titel";

const TextsTab = () => {

    return (
        <>
            <div className="w-full flex flex-col p-4">
                <Title title='متون سایت' className='md:text-lg mb-3' />
                <div className="flex flex-col gap-4">
                    <Tabs aria-label="Options" className="border-b pb-3">
                        <Tab key="1" title="صفحه اصلی">
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Main id='1' />
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab key="2" title="تابلوها">
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Main id='2' />
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab key="3" title="تابلوآماده">
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Main id='6' />
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab key="4" title="تابلوموزیکال">
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Main id='7' />
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab key="5" title="دسته بندی">
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Main id='4' />
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab key="6" title="هنرمند">
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Main id='3' />
                                </CardBody>
                            </Card>
                        </Tab>
                        <Tab key="7" title="مجله هنری">
                            <Card className="!shadow-none rounded-none">
                                <CardBody>
                                    <Main id='5' />
                                </CardBody>
                            </Card>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        </>
    );
};

export default TextsTab;